import { render, staticRenderFns } from "./JdsIcon.vue?vue&type=template&id=55b434a6&"
import script from "./JdsIcon.vue?vue&type=script&lang=ts&"
export * from "./JdsIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports